<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row" style="display: flex !important;" [ngClass]="{direction_ltr:dir == 'ltr'}">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" [ngClass]="{search_box_ltr:dir == 'ltr',en:lang == 2}" name="search_all"
            [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)" placeholder="جستجو..." autocomplete="off"
            style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div [ngStyle]="{'direction' : lang == 2 ? 'ltr' : 'rtl'}" class="service_pager"
            [ngClass]="{service_pager_en:dir == 'ltr'}">
            <span>
                <div class="video_div1" (click)="open_video()" *ngIf="video">
                    <mat-icon class="video">smart_display</mat-icon>
                </div>
                <button class="new1" (click)='change_task(1,1,"","",1,"","")' [disabled]='new_status'>
                    <span>جدید</span>
                </button>
                <button class="search1" (click)='change_task(3,3,"","",1,"","")'>
                    <span>فیلتر</span>
                </button>
                <div class="pager_pe" [ngClass]="{pager_en:dir == 'ltr'}">
                    <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-fast-forward"></i></button>
                    <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-forward"></i></button>
                    <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-backward"></i></button>
                    <button (click)="check_access(4,1,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-fast-backward"></i></button>
                </div>
                <div class='navigation' [ngClass]="{en_navigation_number:lang==2}"><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
            </span>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs">
        <div class="pager_checkbox" [ngClass]="{pager_checkbox_en:lang == 2}">
            <div class="pager_icon_en">
                <div class="excel">
                    <img src="../../../../../assets/images/excel.png" class="excel_icon cursor"
                        (click)="load_data(1,2,1,-1)">
                    <a href="" id="excel"><i class="far fa-file-excel" [hidden]="true"></i></a>
                </div>
                <div style="display: inline-block;">
                    <mat-checkbox (change)="get_select($event.checked)" [(indeterminate)]="indeterminate">
                    </mat-checkbox>
                </div>
                <div class="cursor" (click)="check_access(3,0,selected_record,1,1)">
                    <i class="far fa-trash-alt trash icon"></i>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="content-body control-content-body" [ngClass]="{content_body_en:dir=='ltr'}"
    (window:resize)="change_resize()">
    <mat-table [dataSource]="dataSource" class='table-scroll mat_table_fa_without_scroll pe1'
        [ngClass]="{mat_table_en_without_scroll:dir=='ltr',en1:dir == 'ltr'}">

        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:45px'>
                <span>ردیف</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:45px'>{{ i + page_number_first }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef>
                <span>عنوان</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index"
                (click)='change_task(2,x.site_cheque_status_id,x.site_cheque_status_title,x.site_cheque_status_title2,x.status_id,x.site_cheque_status_sort,x.site_cheque_status_color)'>
                <div class="right" style="display: inlinee;float: right;">{{ x.site_cheque_status_title }}</div>
                <span style="float:left;padding-left:5px" [ngStyle]="{color:x.site_cheque_status_color}">
                    <i class="fas fa-square-full"></i>
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="default">
            <mat-header-cell *matHeaderCellDef>
                <span>پیش فرض</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index">
                <span (click)='change_default(i,x.site_cheque_status_default,x.site_cheque_status_id)'>
                    <span *ngIf="x.site_cheque_status_default == 0"><i class="far fa-star icon"></i> </span>
                    <span *ngIf="x.site_cheque_status_default == 1"><i class="fas fa-star icon" style="color:blue;"></i>
                    </span>
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="not_used">
            <mat-header-cell *matHeaderCellDef>
                <span>استفاده نشده</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index">
                <span (click)='change_not_used(i,x.site_cheque_status_not_used,x.site_cheque_status_id)'>
                    <span *ngIf="x.site_cheque_status_not_used == 0"><i class="far fa-star icon"></i> </span>
                    <span *ngIf="x.site_cheque_status_not_used == 1"><i class="fas fa-star icon"
                            style="color: blue;"></i> </span>
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="spent">
            <mat-header-cell *matHeaderCellDef>
                <span>خرج شده</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index">
                <span (click)='change_default_spent(i,x.site_cheque_status_spent,x.site_cheque_status_id)'>
                    <span *ngIf="x.site_cheque_status_spent == 0"><i class="far fa-star icon"></i> </span>
                    <span *ngIf="x.site_cheque_status_spent == 1"><i class="fas fa-star icon" style="color: blue;"></i>
                    </span>
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="not_change">
            <mat-header-cell *matHeaderCellDef>
                <span>سیستمی</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index">
                <span (click)='change_not_change(i,x.site_cheque_status_not_change,x.site_cheque_status_id)'>
                    <span *ngIf="x.site_cheque_status_not_change == 0"><i class="far fa-star icon"></i> </span>
                    <span *ngIf="x.site_cheque_status_not_change == 1"><i class="fas fa-star icon"
                            style="color: blue;"></i> </span>
                </span>
            </mat-cell>
        </ng-container>


        <ng-container matColumnDef="sort">
            <mat-header-cell *matHeaderCellDef [hidden]="true">
                <span>سیستمی</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" [hidden]="true">{{ x.site_cheque_status_sort }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef>
                <span>وضعیت</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index"
                (click)='change_task(2,x.site_cheque_status_id,x.site_cheque_status_title,x.site_cheque_status_title2,x.status_id,x.site_cheque_status_sort,x.site_cheque_status_color)'>
                <span>{{ x.status_title }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef style="max-width:70px">
                <span>شناسه</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:70px"
                (click)='change_task(2,x.site_cheque_status_id,x.site_cheque_status_title,x.site_cheque_status_title2,x.status_id,x.site_cheque_status_sort,x.site_cheque_status_color)'>
                {{ x.site_cheque_status_id }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="operation">
            <mat-header-cell *matHeaderCellDef style='max-width:50px'>
                <span>عملیات</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:50px'>
                <mat-checkbox (change)="get_select_records(i)" name="selete_records[]" [value]="x.site_cheque_status_id"
                    [checked]="x.checked"></mat-checkbox>
                <span (click)="check_access(3,0,x.site_cheque_status_id,0,1)"><i class="far fa-trash-alt icon"
                        style='margin:0px 4px;'></i></span>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
        <mat-row *matRowDef="let row;columns:displayedColumns;let i = index" (click)="mat_table_selectedRow = row"
            (mouseenter)="mat_table_hoverRow = row"
            [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
            class="cursor"></mat-row>
    </mat-table>

    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets//images/preview.png">
            </div>
            <div class="preview2">{{ messageService.get_no_record_text() }}</div>
        </div>
    </div>
</div>


<ngx-smart-modal #myModal identifier="myModal" class="pe" [ngClass]="{en:lang==2}" (onClose)="ModalClose()">
    <form [formGroup]="form1_group">
        <div class="dialog_title1">
            <span>{{ messageService.get_title(type_task) }}</span>
        </div>
        <div class="row">
            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> عنوان : </span>
                    <span *ngIf="lang == 2"> Title : </span>
                    <input class='wh-input' formControlName="title" autocomplete="off" required>
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
                <label for="Title2" class='wh-label'>
                    <span *ngIf="lang == 1"> عنوان انگلیسی : </span>
                    <span *ngIf="lang == 2"> English title : </span>
                    <input class='wh-input' formControlName="title2" autocomplete="off" required>
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}" [hidden]="true">
                <label for="sort" class='wh-label'>
                    <span *ngIf="lang == 1"> ترتیب : </span>
                    <span *ngIf="lang == 2"> Sort : </span>
                    <input class='wh-input' formControlName="sort" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> وضعیت نمایش : </span>
                    <span *ngIf="lang == 2"> Display status : </span>
                    <select class='wh-input' formControlName="status_id" required>
                        <option value=""></option>
                        <option *ngFor='let x of list_status' value="{{ x.status_id }}">
                            <span>{{ x.status_title }}</span>
                        </option>
                    </select>
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
                <label for="color" class='wh-label'>
                    <span *ngIf="lang == 1"> رنگ : </span>
                    <span *ngIf="lang == 2"> color : </span>
                    <input type="color" class='wh-input' formControlName="color" autocomplete="off">
                </label>
            </div>

        </div>
        <div class="row">
            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12' style='margin-top:5px;text-align:center'>
                <button class="btn_pe" (click)="check_access(type_task,0,0,0,1)" [disabled]="!form1_group.valid">
                    {{ messageService.get_event_title(type_task) }}
                </button>
            </div>
        </div>
    </form>
</ngx-smart-modal>

<ngx-smart-modal #myModalSearch identifier="myModal" class="pe" [ngClass]="{en:lang==2}" (onClose)="ModalClose()">
    <form [formGroup]="form1_search_group">
        <div class="dialog_title1">
            <span>{{ messageService.get_title(type_task) }}</span>
        </div>
        <div class="row">
            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
                <label for="title_search" class='wh-label'>
                    <span *ngIf="lang == 1"> عنوان : </span>
                    <span *ngIf="lang == 2"> Title : </span>
                    <input class='wh-input' formControlName='title_search' autocomplete="off">
                </label>
            </div>
            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
                <label for="title2_search" class='wh-label'>
                    <span *ngIf="lang == 1"> عنوان انگلیسی : </span>
                    <span *ngIf="lang == 2"> English title : </span>
                    <input class='wh-input' formControlName='title2_search' autocomplete="off">
                </label>
            </div>
            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> وضعيت نمايش : </span>
                    <span *ngIf="lang == 2"> Display status : </span>
                    <select class='wh-input' formControlName='status_id_search' pattern="[0-9]{1,}">
                        <option value=""></option>
                        <option *ngFor='let x of list_status' value="{{ x.status_id }}">
                            <span>{{ x.status_title }}</span>
                        </option>
                    </select>
                </label>
            </div>

        </div>
        <div class="row">
            <div class='col-xl-12 col-lg-12  col-md-12  col-sm-12 col-xs-12'
                style='margin-top:5px;text-align:center;font-family:irsans'>
                <button class="btn_pe" (click)="check_access(4,1,0,1,1)">
                    {{ messageService.get_event_title(type_task) }}
                </button>
            </div>
        </div>
    </form>
</ngx-smart-modal>